// @flow
import * as React from 'react';

import { storedSession } from 'common/services/StoredSession';
import useClientIdFromHostName from 'common/hooks/useClientIdFromHostname';
import useClientIdFromCookie from './useClientIdFromCookie';
import useClientIdFromQuery from './useClientIdFromQuery';

export type ResolvedClientId = {
    clientIdFromQuery: ?string,
    clientIdFromHostName: ?string,
    localResolvedClientId: ?string,
    providerId: ?string
};

/**
 * Get the client Id from either
 * 1. The hostname (clientid)
 * 2. the query (?clientId)
 * 3. the stored cookie
 */
const useUrlResolvedClientId = (): ResolvedClientId => {
    const {
        clientId: clientIdFromHostName,
        providerId: providerIdFromHostName
    } = useClientIdFromHostName();

    const {
        clientId: clientIdFromQuery,
        providerId: providerIdFromQuery
    } = useClientIdFromQuery();

    const clientIdFromCookie = useClientIdFromCookie();

    React.useEffect(() => {
        const localResolvedClientId = clientIdFromHostName || clientIdFromQuery;
        if (clientIdFromCookie !== localResolvedClientId) {
            storedSession.setClientId(
                clientIdFromHostName || clientIdFromQuery
            );
        }
    }, [clientIdFromCookie, clientIdFromHostName, clientIdFromQuery]);

    return {
        clientIdFromQuery,
        clientIdFromHostName,
        localResolvedClientId:
            clientIdFromHostName || clientIdFromQuery || clientIdFromCookie,
        providerId: providerIdFromHostName || providerIdFromQuery
    };
};

export default useUrlResolvedClientId;
